import { Variety } from '../../../../../../services/entities/impl/blfApi/schemas/variety';
import { getStageColor } from '../../../../../reports/blueberry/utils/getStageColor';
import { StageCount, StageCountDatasetValue } from '../types';

export const useStagesCountDataset = (
  stageCounts: StageCount[],
  stages: Variety['stages']
): StageCountDatasetValue[] => {
  const detectedsStageCountMap = new Map(
    stageCounts.map((item) => [item.stageId, item.count])
  );

  const allStagesCountDataset = new Map(
    stages.map((item) => [item.id, detectedsStageCountMap.get(item.id) ?? 0])
  );

  const dataset = stages.map((stage) => {
    return {
      id: stage.id,
      value: allStagesCountDataset.get(stage.id) ?? 0,
      label: stage.name,
      color: getStageColor(stage),
      order: stage.order ?? -1,
    };
  });

  return dataset;
};
